import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { CircleCheck } from 'lucide-react';
import { validatePermission } from 'actions';
import { cooperplaceApi } from 'services/api';
import { platesLabel } from '../Candidates/contract';
import { attendancePath, kanbanReturnState, saveAttendanceSession } from './session';
import RefusalActions from '../Refusals/Actions';

export default function AttendanceActions({ candidate, context, onChanged, onRowError }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [busy, setBusy] = useState(false);
  const [refusalOpen, setRefusalOpen] = useState(false);
  const [error, setError] = useState(null);
  const pending = useRef(false);
  const active = useRef(true);
  useEffect(() => {
    active.current = true;
    return () => {
      active.current = false;
    };
  }, []);
  const preLoad = context.item.type === 'PRE_LOAD';
  const allowed = validatePermission(preLoad ? 'ATENDER_PRECARGA' : 'ATENDER_CARGA');
  const enabled =
    allowed &&
    candidate.evaluation === 'ELIGIBLE' &&
    // Sem motorista também pode: o usuário informa o motorista no cadastro da viagem (5615).
    !candidate.refusal.active;
  async function attend() {
    if (!enabled || refusalOpen || pending.current) return;
    pending.current = true;
    setBusy(true);
    setError(null);
    onRowError?.(null);
    try {
      const { data } = await cooperplaceApi.post(
        `/control-tower/loads/${context.item.loadId}/candidates/${candidate.vehicleId}/attendance-context`,
      );
      if (!active.current) return;
      const record = saveAttendanceSession(
        data,
        context,
        kanbanReturnState(location.state, context, candidate.candidateId),
      );
      navigate(
        attendancePath(
          `/${record.loadKind === 'PRE_LOAD' ? 'pre-cargas' : 'cargas'}/${record.loadId}`,
          record,
        ),
      );
    } catch (failure) {
      if (active.current) {
        const message =
          failure?.response?.data?.message ||
          failure.message ||
          'Não foi possível preparar o atendimento.';
        setError(message);
        onRowError?.(message);
      }
    } finally {
      pending.current = false;
      if (active.current) setBusy(false);
    }
  }
  return (
    <div>
      <div className="tc-c-row-actions">
        {!candidate.refusal.active && (
          <button
            type="button"
            className="tc-c-accept"
            disabled={!enabled || busy || refusalOpen}
            onClick={attend}
            title={
              enabled
                ? 'Atender com este candidato'
                : 'Exige permissão, motorista e candidato elegível sem recusa ativa'
            }
            aria-label={`Atender ${platesLabel(candidate)}`}
          >
            <CircleCheck size={18} aria-hidden="true" />
          </button>
        )}
        <RefusalActions
          candidate={candidate}
          context={context}
          disabled={busy}
          onOpenChange={setRefusalOpen}
          onChanged={onChanged}
        />
      </div>
      {busy && <span role="status">Validando…</span>}
      {error && !onRowError && (
        <div role="alert">
          {error}
          <button type="button" onClick={onChanged}>
            Atualizar fila
          </button>
        </div>
      )}
    </div>
  );
}
